module.exports = __webpack_public_path__ + "static/home-30e080990f7b3fcba4ff728abcbdf9d0.jpg";